import script from "./leftline.vue?vue&type=script&setup=true&lang=js"
export * from "./leftline.vue?vue&type=script&setup=true&lang=js"

import "./leftline.vue?vue&type=style&index=0&id=7b636cbe&scoped=true&lang=css"
script.__scopeId = "data-v-7b636cbe"

export default script